import * as Yup from 'yup';

const validationSchema = ({ t }) => Yup.object().shape({
  name: Yup.string().typeError('Must string').required(t('general.message.field_required')),
  description: Yup.string().required(t('org.employee.form.field_cannot_empty')),
});

export default validationSchema;
